var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 31.0002L25 28.0002M28 31.0002C29.3968 30.469 30.7369 29.799 32 29.0002M28 31.0002V36.0002C28 36.0002 31.03 35.4502 32 34.0002C33.08 32.3802 32 29.0002 32 29.0002M25 28.0002C25.5321 26.6197 26.2022 25.2963 27 24.0502C28.1652 22.1872 29.7876 20.6533 31.713 19.5943C33.6384 18.5354 35.8027 17.9866 38 18.0002C38 20.7202 37.22 25.5002 32 29.0002M25 28.0002H20C20 28.0002 20.55 24.9702 22 24.0002C23.62 22.9202 27 24.0002 27 24.0002M20.5 32.5002C19 33.7602 18.5 37.5002 18.5 37.5002C18.5 37.5002 22.24 37.0002 23.5 35.5002C24.21 34.6602 24.2 33.3702 23.41 32.5902C23.0213 32.2193 22.5093 32.0049 21.9722 31.9883C21.4352 31.9717 20.9109 32.154 20.5 32.5002Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocket_icon.10b93bb7a23800b55502a80a695be0b0.svg";
export { ForwardRef as ReactComponent };